import React, { useContext } from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { selectMomentLocalizer } from 'models/localization';
import Routes from 'Routes';
import { WebinarType } from 'models/webinars';
import { SearchFieldContext } from 'components/SearchFieldContext';
import TextHighlighter from 'components/TextHighlighter';
import { FETCH_ASSETS_URL } from 'appenv';

import SearchResultLink from './components/SearchResultLink';
import SearchResultImage from './components/SearchResultImage';
import TitleContainer from './components/TitleContainer';
import DescriptionContainer from './components/DescriptionContainer';
import InfoContainer from './components/InfoContainer';

const WebinarIcon = `${FETCH_ASSETS_URL}/assets/icon-webinar.svg`;

const DateTimeContainer = styled(DescriptionContainer)`
  margin-top: 5px;
`;

const WebinarSearchResultItem = ({
  type,
  id,
  name,
  startAt,
  endAt,
  variant,
}: {
  type: WebinarType;
  id: string;
  name: string;
  startAt: string;
  endAt: string;
  variant: 'compact' | 'standard';
}) => {
  const { searchKeyword } = useContext(SearchFieldContext);
  const momentLocalizer = useSelector(selectMomentLocalizer);

  const startTime = startAt ? momentLocalizer(startAt) : null;
  const endTime = endAt ? momentLocalizer(endAt) : null;
  const timeZoneOffset = startAt ? `GMT${momentLocalizer(startAt).format('Z')}` : null;

  return (
    <SearchResultLink to={Routes.webinarSession(id)} variant={variant}>
      <SearchResultImage src={WebinarIcon} variant={variant} />
      <InfoContainer>
        <TitleContainer>
          <TextHighlighter
            searchWords={[searchKeyword]}
            textToHighlight={name}
          />
        </TitleContainer>
        {type === WebinarType.Live && (
          <DateTimeContainer>
            { `${startTime?.format('HH:mm')} - ${endTime?.format('HH:mm')}, ${startTime?.format('MMM DD')} (${timeZoneOffset})` }
          </DateTimeContainer>
        )}
      </InfoContainer>
    </SearchResultLink>
  );
};

export default WebinarSearchResultItem;
